import React from 'react'

class RoutingError extends React.Component {
  componentWillMount() {
    document.location = `/404`
  }

  render() { return null }
}

export default RoutingError
